import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreError } from '../../../Types/StoreTypes';

const initialState: StoreError = {
    error: false,
    errorMessage: '',
    status: 0,
    errorRedirectCounter: parseInt(localStorage.getItem('errorRedirectCounter') || '0'),
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setError: (state, action: PayloadAction<StoreError['error']>) => {
            state.error = action.payload;
        },
        setErrorMessage: (state, action: PayloadAction<StoreError['errorMessage']>) => {
            state.errorMessage = action.payload;
        },
        setErrorStatus: (state, action: PayloadAction<StoreError['status']>) => {
            state.status = action.payload;
        },
        setErrorRedirectCounter: (state, action: PayloadAction<StoreError['errorRedirectCounter']>) => {
            state.errorRedirectCounter = action.payload;
        },
    },
});

export const { setError, setErrorMessage, setErrorStatus, setErrorRedirectCounter } = errorSlice.actions;

export default errorSlice.reducer;
